import { ButtonType } from '@prisjakt/ui/button';
import {
  Dropdown,
  DropdownContent,
  DropdownToggle,
} from '@prisjakt/ui/dropdown';
import React, { useCallback, useState } from 'react';

import * as S from './styles';

export type Option = {
  title: string;
  value?: string | number;
};

type OwnProps = {
  className?: string;
  defaultSelected?: Option;
  title: string;
  options: Option[];
  onFilterChange: (option: Option) => void;
};

const FilterDropdown = ({
  className,
  defaultSelected,
  title,
  onFilterChange,
  options,
}: OwnProps) => {
  const [selected, setSelected] = useState<Option | undefined>(
    defaultSelected || options[0]
  );

  const handleOnClick = useCallback(
    (option: Option) => {
      setSelected(option);
      onFilterChange(option);
    },
    [onFilterChange]
  );

  return (
    <Dropdown
      closeOnItemClick
      className={className}
      containerProps={{ 'data-test': 'FilterDropdown' }}
    >
      <DropdownToggle
        showActiveIcon
        type={ButtonType.TEXT}
        containerProps={{ 'data-test': 'DropdownToggle' }}
      >
        {`${title} ${selected?.title.toLowerCase()}`}
      </DropdownToggle>
      <DropdownContent width={260}>
        {options.sort().map(option => {
          return (
            <S.DropdownItem
              key={option.title}
              onClick={() => handleOnClick(option)}
              disabled={Boolean(selected?.title === option.title)}
              data-test="DropdownOption"
            >
              {option.title}
            </S.DropdownItem>
          );
        })}
      </DropdownContent>
    </Dropdown>
  );
};

export default FilterDropdown;
